<template>
  <div>
    <ed-session ref="session" />
    <ed-socket ref="socket" />
    <ed-notify ref="notify" />
    <ed-dialog ref="dialog" />
    <ed-loading ref="loading" />
    <ed-request ref="request"/>
    <router-view v-if="!loadingContent" />
  </div>
</template>

<script>
import {
  EdSocket,
  EdSession,
  EdRequest,
  EdNotify,
  EdDialog,
  EdLoading,
} from "root";

export default {
  name: "app",
  components: {
    EdSocket,
    EdSession,
    EdRequest,
    EdNotify,
    EdDialog,
    EdLoading,
  },
  data() {
    return {
      loadingContent: true,
    };
  },

  mounted() {

    this.$root.$session = this.$refs.session;
    this.$root.$socket = this.$refs.socket;
    this.$root.$request = this.$refs.request;
    this.$root.$notify = this.$refs.notify;
    this.$root.$dialog = this.$refs.dialog;
		this.$root.$loading = this.$refs.loading;
    
    this.$root.$session.sub_domain = "web";

    $(".carregando").html("Carregando ambiente...");
    this.getEnv();
    this.getWindow();
  },

  created() {
    
  },

  methods: {
    getWindow() {
      var self = this;

      this.$root.$session.window = {
        height: window.innerHeight,
        width: window.innerWidth,
      };

      window.addEventListener("resize", function (e) {
        self.$root.$session.window = {
          height: window.innerHeight,
          width: window.innerWidth,
        };
      });
    },

    getEnv() {
      this.loadingContent = true;

      this.$root.$request.get("common/env").then((result) => {

        $(".carregando").hide();

        if (result.status == 200 && result.data) {
          this.$root.$session.deleteCookie("version");
          this.$root.$session.setCookie("version", result.data.app_version);

          this.$root.$session.env = result.data;
          this.loadingContent = false;
        } else {
          $(".carregando").html(result.msg);
          $(".carregando").css({ color: "red" });
        }
      });
    },
  },
};
</script>


<style lang="scss">
@import "~assets/styles/default.scss";
</style>



// WEBPACK FOOTER //
// index.vue?5f2f6865